import * as React from 'react';

export const JumpsContext = React.createContext<object[]>([]);
